export default {
  computed: {
    isCheckout() {
      return this.checkout && this.checkout.authType === 'registration';
    },
    hybridAuth() {
      return process.env.VUE_APP_SOCIAL_AUTH === 'true';
    },
  },
  methods: {
    closeCheckout() {
      this.showCloseCheckoutModal();
    },
  },
};
